import React from 'react';
import ReactDOM, { Container } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import './index.css';
import { BrowserRouter } from 'react-router';
import { Provider } from 'react-redux';
import store from './store/store.ts';
import { FeatureFlagsProvider } from './helpers/FeatureFlagsContext.tsx';
import { theme } from './theme/index.ts';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { initializeSentry, SentryAppBoundary } from './sentry.tsx';
import { SessionWarningModal } from './components/modals/SessionWarningModal/SessionModal.tsx';
import { InternetConnectionCheckModal } from './components/modals/InternetConnectionCheckModal.tsx';
import { ThemeProvider } from '@mui/material/styles';
import { VITE_PRELOAD_LOADED } from './constants/common.ts';

const queryClient = new QueryClient();
const SentryProfiledApp = Sentry.withProfiler(App);

initializeSentry();

window.addEventListener('vite:preloadError', (e) => {
  e.preventDefault();
  if (!sessionStorage.getItem(VITE_PRELOAD_LOADED)) {
    sessionStorage.setItem(VITE_PRELOAD_LOADED, 'true');
    window.location.reload();
  }
});

ReactDOM.createRoot(document.getElementById('root') as Container, {
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <SentryAppBoundary>
            <FeatureFlagsProvider>
              <BrowserRouter basename={import.meta.env.BASE_URL}>
                <SentryProfiledApp />
                <SessionWarningModal />
                <InternetConnectionCheckModal />
              </BrowserRouter>
            </FeatureFlagsProvider>
          </SentryAppBoundary>
        </ThemeProvider>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);
